import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React, { useState } from 'react';
import { Text, TouchableOpacity, View, Platform } from 'react-native';
import styled from 'styled-components';
import isEqual from 'react-fast-compare';
var HtmlRowComponent = styled.tr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n"])));
var renderContent = function renderContent(_ref) {
  var entry = _ref.entry,
    options = _ref.options,
    styles = _ref.styles;
  var content = options.content,
    getValue = options.value;
  if (!content) {
    if ('web' === Platform.OS) {
      content = function content(_ref2) {
        var value = _ref2.value;
        return /*#__PURE__*/React.createElement("span", {
          style: styles === null || styles === void 0 ? void 0 : styles.content
        }, value);
      };
    } else {
      content = function content(_ref3) {
        var value = _ref3.value;
        return /*#__PURE__*/React.createElement(Text, {
          style: styles === null || styles === void 0 ? void 0 : styles.content
        }, value);
      };
    }
  }
  var valueToRender = entry[options.key];
  if (getValue) {
    valueToRender = getValue({
      entry: entry,
      value: valueToRender
    });
  }
  var rendered = content({
    entry: entry,
    value: valueToRender
  });
  if ('string' === typeof rendered) {
    if ('web' === Platform.OS) {
      rendered = /*#__PURE__*/React.createElement("span", {
        style: styles === null || styles === void 0 ? void 0 : styles.content
      }, rendered);
    } else {
      rendered = /*#__PURE__*/React.createElement(Text, {
        style: styles === null || styles === void 0 ? void 0 : styles.content
      }, rendered);
    }
  }
  return rendered;
};
var Row = function Row(_ref4) {
  var entry = _ref4.entry,
    columns = _ref4.columns,
    index = _ref4.index,
    dimensions = _ref4.dimensions,
    styles = _ref4.styles,
    htmlTable = _ref4.htmlTable;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showHidden = _useState4[0],
    setShowHidden = _useState4[1];
  var style = _objectSpread({
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: 'lightgray',
    borderBottomStyle: 'solid',
    paddingHorizontal: 16
  }, styles === null || styles === void 0 ? void 0 : styles.container);
  if (index % 2 === 0) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      backgroundColor: '#f0f0f0'
    }, styles === null || styles === void 0 ? void 0 : styles.alternate);
  }
  if (hover) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      backgroundColor: '#f0f0f0'
    }, styles === null || styles === void 0 ? void 0 : styles.hover);
  }
  var defaultCellStyle = _objectSpread({
    flex: 1,
    borderLeftWidth: 1,
    borderLeftColor: 'lightgray',
    borderLeftStyle: 'solid',
    paddingHorizontal: 8,
    paddingVertical: 8
  }, styles === null || styles === void 0 ? void 0 : styles.cell);
  var hiddenStyle = {
    flexDirection: 'row',
    paddingVertical: 6
  };
  var hiddenLabelStyle = _objectSpread({
    flex: 1,
    maxWidth: 260,
    paddingHorizontal: 22,
    borderBottomWidth: 1,
    borderBottomColor: 'lightgray'
  }, styles === null || styles === void 0 ? void 0 : styles.hiddenLabel);
  var hiddenCellStyle = {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: 'lightgray'
  };
  var foundFirst = false;
  var shownColumns = [];
  var hiddenColumns = [];
  var cssHover = htmlTable && !(styles === null || styles === void 0 ? void 0 : styles.hover);
  columns.forEach(function (options) {
    var minViewportWidth = options.minViewportWidth;
    if (options.hidden) {
      // Ignore
    } else if (((dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) || 999999999) < (minViewportWidth || 0)) {
      hiddenColumns.push(options);
    } else {
      shownColumns.push(options);
    }
  });
  var RowComponent = htmlTable ? HtmlRowComponent : View;
  return /*#__PURE__*/React.createElement(React.Fragment, null, cssHover && /*#__PURE__*/React.createElement("style", null, ".preflight-table-row:hover{background-color: #f0f0f0}"), /*#__PURE__*/React.createElement(RowComponent, {
    className: "preflight-table-row",
    style: style,
    onMouseEnter: cssHover ? undefined : function () {
      return setHover(true);
    },
    onMouseLeave: cssHover ? undefined : function () {
      return setHover(false);
    }
  }, shownColumns.map(function (options) {
    var key = options.key,
      width = options.width;
    var cellStyle = options.cellStyle;
    var showHiddenButton;
    if (hiddenColumns.length && !foundFirst) {
      if (htmlTable) {
        showHiddenButton = /*#__PURE__*/React.createElement("span", {
          onClick: function onClick() {
            return setShowHidden(!showHidden);
          },
          style: {
            paddingRight: 6,
            cursor: 'pointer'
          }
        }, showHidden ? '⊖' : '⊕');
      } else {
        showHiddenButton = /*#__PURE__*/React.createElement(TouchableOpacity, {
          onPress: function onPress() {
            return setShowHidden(!showHidden);
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            paddingHorizontal: 6
          }
        }, /*#__PURE__*/React.createElement(Text, {
          style: {
            fontWeight: 'bold'
          }
        }, showHidden ? '⊖' : '⊕')));
      }
    }
    cellStyle = _objectSpread(_objectSpread({}, defaultCellStyle), cellStyle);
    if (!foundFirst) {
      cellStyle.borderLeftWidth = 0;

      // TODO Build a better way to keep showHiddenButton inline.
      cellStyle.flexDirection = 'row';
      foundFirst = true;
    }
    if (width) {
      cellStyle.flex = 0;
      cellStyle.flexBasis = width;
    }
    if (htmlTable) {
      cellStyle.paddingLeft = cellStyle.paddingHorizontal;
      cellStyle.paddingRight = cellStyle.paddingHorizontal;
      cellStyle.paddingTop = cellStyle.paddingVertical;
      cellStyle.paddingBottom = cellStyle.paddingVertical;
      return /*#__PURE__*/React.createElement("td", {
        key: key,
        style: cellStyle
      }, showHiddenButton, renderContent({
        entry: entry,
        options: options,
        styles: styles
      }));
    } else {
      return /*#__PURE__*/React.createElement(View, {
        style: cellStyle,
        key: key
      }, showHiddenButton, renderContent({
        entry: entry,
        options: options,
        styles: styles
      }));
    }
  })), showHidden && hiddenColumns.map(function (options) {
    var key = options.key,
      label = options.label;
    var content = options.content,
      cellStyle = options.cellStyle;
    cellStyle = _objectSpread(_objectSpread({}, hiddenCellStyle), cellStyle);
    var hiddenColumnsView = /*#__PURE__*/React.createElement(View, {
      key: key,
      style: hiddenStyle
    }, /*#__PURE__*/React.createElement(View, {
      style: hiddenLabelStyle
    }, /*#__PURE__*/React.createElement(Text, {
      style: {
        fontWeight: 'bold'
      }
    }, label)), /*#__PURE__*/React.createElement(View, {
      style: hiddenCellStyle
    }, renderContent({
      entry: entry,
      options: options,
      styles: styles
    })));
    if (htmlTable) {
      return /*#__PURE__*/React.createElement("tr", {
        key: key
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: shownColumns.length
      }, hiddenColumnsView));
    } else {
      return hiddenColumnsView;
    }
  }));
};
var rowPropsAreEqual = function rowPropsAreEqual(prevProps, nextProps) {
  if (nextProps.memoizeRows) {
    var prevColumns = prevProps.columns.map(function (column) {
      return {
        key: column.key,
        label: column.label,
        hidden: column.hidden
      };
    });
    var nextColumns = nextProps.columns.map(function (column) {
      return {
        key: column.key,
        label: column.label,
        hidden: column.hidden
      };
    });
    return isEqual(prevProps.entry, nextProps.entry) && isEqual(prevProps.dimensions, nextProps.dimensions) && isEqual(prevProps.index, nextProps.index) && isEqual(prevProps.styles, nextProps.styles) && isEqual(prevColumns, nextColumns);
  } else {
    return isEqual(prevProps, nextProps);
  }
};
export default React.memo(Row, rowPropsAreEqual);